






























import { Component, Vue, Mixins, Ref } from 'vue-property-decorator'
import InputWithLabel from '@/components/common/atoms/InputWithLabel.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import PaginationButton from '@/components/common/organisms/PaginationButton.vue'
import NotificationApis, {
  NotificationSearchQuery,
  NotificationItem,
} from '@/mixins/requests/admin/NotificationApis.vue'
import NotificationTable from '@/components/admin/organisms/NotificationTable.vue'
import { ApiResponse } from '@/plugins/http'

@Component({
  components: {
    InputWithLabel,
    ButtonBase,
    PaginationButton,
    NotificationTable,
  },
})
export default class Notification extends Mixins(NotificationApis) {
  // ref: 上部ページネーション
  @Ref() paginationButtonTop!: PaginationButton
  // ref: 下部ページネーション
  @Ref() paginationButtonBottom!: PaginationButton

  private notificationTitle = ''
  private currentSearchQuery: NotificationSearchQuery = {}
  private notificationItems: NotificationItem[] | null = null

  /**
   * [Vue] 画面読み込み時：初期処理
   */
  private async mounted(): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      await this.currentSearch(null)
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 「新規作成」ボタンクリック処理
   */
  private async onClickAddButton(): Promise<void> {
    await this.$router.push({ name: 'AdminNotificationEdit' })
  }

  /**
   * 「検索」ボタンクリック処理
   */
  private async onClickSearchButton(): Promise<void> {
    await this.currentSearch(null)
  }

  /**
   * お知らせ一覧取得
   */
  private async currentSearch(paginatePos: string | null): Promise<void> {
    this.currentSearchQuery = {}
    if (this.notificationTitle) {
      this.currentSearchQuery.title = this.notificationTitle
    }

    let currentPage: number
    if (paginatePos === 'top') currentPage = this.paginationButtonTop.paginationCurrentPage
    else if (paginatePos === 'bottom') currentPage = this.paginationButtonBottom.paginationCurrentPage
    else currentPage = 1

    const notificationObject = await this.searchNotificationItemsApi(this.currentSearchQuery, currentPage)

    this.notificationItems = notificationObject.responses
    if (this.paginationButtonTop && this.paginationButtonBottom) {
      this.paginationButtonTop.paging(notificationObject.pagination)
      this.paginationButtonBottom.paging(notificationObject.pagination)
    }
  }

  /**
   * お知らせ件名クリック処理
   */
  private async onClickTitleLabel(notificationId: number): Promise<void> {
    await this.$router.push({ name: 'AdminNotificationEdit', query: { notificationId: notificationId.toString() } })
  }

  /**
   * 「削除」ボタンクリック処理
   */
  private async onClickDeleteButton(notificationId: number): Promise<void> {
    if (confirm('削除しますか？')) {
      Vue.prototype.$loading.start()
      await this.deleteNotificationItemApi(
        notificationId,
        async () => {
          await this.currentSearch('top')
        },
        async (error: ApiResponse | null) => {
          if (error && error.status === 400) {
            Vue.prototype.$logger.log(error)
            alert(error.message)
          }
        }
      )
      Vue.prototype.$loading.complete()
    }
  }

  /** ページネーションボタンクリック処理 */
  private async onClickTopPaginationButton(): Promise<void> {
    await this.currentSearch('top')
  }

  /** ページネーションボタンクリック処理 */
  private async onClickBottomPaginationButton(): Promise<void> {
    await this.currentSearch('bottom')
  }
}
